export function buildOrderLeadProducts(entities, tableData, helpers) {
  const products = [];

  Object.entries(entities).forEach(([groupKey, groupObj]) => {
    if (groupKey === 'subscriptions') {
      return;
    }

    Object.entries(groupObj)
        .filter(([key]) => key !== 'total' && key !== 'items')
        .forEach(([productId, count]) => {
          if (!count) {
            return;
          }

          let name = '';

          if (groupKey === 'test') {
            name = (tableData.test ?? []).find(
                (row) => String(row.product_id) === String(productId),
            )?.product ?? helpers.getReportName(productId);
          } else if (groupKey === 'analytics') {
            name = helpers.analyticsTranslate[productId]
                ?? (tableData.analytics ?? []).find(
                    (row) => String(row.product_id) === String(productId),
                )?.product;
          } else if (groupKey === 'courses') {
            name = Object.values(helpers.companyQuotas?.course_passings?.total ?? {}).find(
                (item) => Number(item.course_id) === Number(productId),
            )?.name
                ?? (tableData.courses ?? []).find(
                    (row) => String(row.product_id) === String(productId),
                )?.product;
          } else if (groupKey === 'professionalDevelopment' || groupKey === 'expertSupport') {
            name = (tableData[groupKey] ?? []).find(
                (row) => String(row.product_id) === String(productId),
            )?.product;
          }

          const type = groupKey === 'professionalDevelopment' || groupKey === 'expertSupport'
              ? 'courses'
              : groupKey;

          products.push({
            id: productId,
            name: name ?? '',
            count: Number(count),
            price: helpers.getProductUnitPrice(groupKey, productId),
            type,
          });
        });
  });

  (entities.subscriptions?.items ?? []).forEach((subscriptionId) => {
    const count = Number(entities.subscriptions?.[subscriptionId]) || 0;

    if (!count) {
      return;
    }

    const subscriptionData = helpers.availableSubscriptions.find(
        (item) => String(item.id) === String(subscriptionId),
    );
    const subscriptionRow = (tableData.subscriptions ?? []).find(
        (row) => String(row.product_id) === String(subscriptionId),
    );

    products.push({
      id: null,
      name: subscriptionData?.title ?? subscriptionRow?.product ?? '',
      count,
      price: helpers.getProductUnitPrice('subscriptions', subscriptionId),
      type: 'subscriptions',
    });
  });

  return products;
}

export function buildOrderLeadRequest(payload) {
  const trimmedComment = payload.comment?.trim();

  return {
    name: payload.name?.trim(),
    email: payload.email?.trim(),
    phone: payload.phone?.trim(),
    company: payload.company?.trim() || null,
    comment: trimmedComment || null,
    products: payload.products,
  };
}
